import React from 'react';
import { Check, X } from 'lucide-react';
export function TargetAudience() {
  return <section className="py-16 md:py-24" data-id="element-176">
      <div className="container mx-auto px-4" data-id="element-177">
        <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-8" data-id="element-178">
          {/* Who it's for */}
          <div className="glass-panel p-8 border-t-4 border-t-amber-500" data-id="element-179">
            <h3 className="text-2xl mb-8 text-white" data-id="element-180">
              Este protocolo ES para ti si:
            </h3>
            <ul className="space-y-5" data-id="element-181">
              {['Eres una mujer profesional de 50+ que maneja múltiples responsabilidades.', 'Sientes que "se te van las palabras" bajo presión o estrés.', 'Te despiertas a las 3 AM preocupada por lo que olvidaste hacer.', 'Eres una hispana trabajadora que valora su claridad mental como su activo más valioso.'].map((text, i) => <li key={i} className="flex gap-4 items-start" data-id="element-182">
                  <div className="mt-1 bg-amber-500/20 rounded-full p-1" data-id="element-183">
                    <Check className="text-amber-400" size={16} data-id="element-184" />
                  </div>
                  <p className="text-steel-300 leading-relaxed" data-id="element-185">{text}</p>
                </li>)}
            </ul>
          </div>

          {/* Who it's not for */}
          <div className="glass-panel p-8 border-t-4 border-t-steel-600" data-id="element-186">
            <h3 className="text-2xl mb-8 text-steel-400" data-id="element-187">
              Este protocolo NO es para ti si:
            </h3>
            <ul className="space-y-5" data-id="element-188">
              {['Buscas una solución médica para enfermedades degenerativas severas.', 'No estás dispuesta a dedicar 10 minutos de calma antes de dormir.', 'Prefieres seguir dependiendo de recordatorios digitales infinitos.'].map((text, i) => <li key={i} className="flex gap-4 items-start" data-id="element-189">
                  <div className="mt-1 bg-steel-800 rounded-full p-1" data-id="element-190">
                    <X className="text-steel-500" size={16} data-id="element-191" />
                  </div>
                  <p className="text-steel-400 leading-relaxed" data-id="element-192">{text}</p>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}